import { AxiosInstance, AxiosResponse } from 'axios';

import {
  GetAllGVOpportunitiesRequestPayload,
  GetAllGVOpportunitiesSuccessPayload,
} from 'pages/GVOpportunities/store/actions';

export default class GVOpportunitiesAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getAllGVOpportunities(
    data: GetAllGVOpportunitiesRequestPayload,
  ): Promise<AxiosResponse<GetAllGVOpportunitiesSuccessPayload>> {
    return this.client.post(
      '/v2/organizations/deal-center/transaction-opportunities/',
      { ...data },
    );
  }
}
